function formatWithThousandSeparator(number) {
    if (number === undefined) {
        return;
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

module.exports = formatWithThousandSeparator;
